import { render, staticRenderFns } from "./ShippingLogDOPop.vue?vue&type=template&id=45affcbe&scoped=true"
import script from "./ShippingLogDOPop.vue?vue&type=script&lang=js"
export * from "./ShippingLogDOPop.vue?vue&type=script&lang=js"
import style0 from "./ShippingLogDOPop.vue?vue&type=style&index=0&id=45affcbe&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45affcbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45affcbe')) {
      api.createRecord('45affcbe', component.options)
    } else {
      api.reload('45affcbe', component.options)
    }
    module.hot.accept("./ShippingLogDOPop.vue?vue&type=template&id=45affcbe&scoped=true", function () {
      api.rerender('45affcbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ShippingLogDOPop.vue"
export default component.exports